import React, { useState, useEffect } from "react";
import "../styles/NewPkLandingPage.css";
import { Input, Modal, Spin } from "antd";
import flag from "../assets/images/pk_testing.svg";
import Arrow from "../assets/images/arrow-n.svg";
import {
  MobilePackage,
  checkNetwork,
  getmsisdn,
  iraqLandingCharge,
  isAuthenticated,
} from "../api/requests";
import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import OTPInput, { ResendOTP } from "otp-input-react";
import Fitflex from "../assets/images/fitflex_logo.png";
import JazzLogo from "../assets/images/ufoneLogo.svg";
import { CloseOutline } from "react-ionicons";

const UfoneLandingPage = (props) => {
  const { t } = useTranslation();

  const [number, setNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [redirectLoading, setRedirectLoading] = useState(true);
  const [error, setError] = useState("");
  const [resendStatus, setResendStatus] = useState();
  const [packageValue, setPackageValue] = useState();
  const [packageName, setPackageName] = useState();
  const [packagePrice, setPackagePrice] = useState();
  const [packageDescription, setPackageDescription] = useState();
  const [terms, setTerms] = useState([]);
  const [resendTimer, setResendTimer] = useState(60);
  let { country, operator, bundle } = useParams();
  const [redirectTo, setRedirectTo] = useState(false);
  const [open, setOpen] = useState(false);

  let tokenCheck = isAuthenticated();
  console.log("token CHeck is :::", tokenCheck);

  useEffect(() => {
    getmsisdn()
      .then((res) => {
        console.log("response: ", res);
        console.log("response status :::", res.status);
        if (res !== undefined) {
          if (res.status === 200) {
            if (res.data !== null) {
              let str = res.data;
              str = str.substring(1);
              setNumber(str);
              console.log("befor login redirect");
              LoginFunction(str);
            } else {
              setRedirectLoading(false);
            }
          } else {
            setRedirectLoading(false);
          }
        } else {
          setRedirectLoading(false);
        }
      })
      .catch((err) => {
        console.log("error is :::", error);
        setRedirectLoading(false);
      });

    let payload = {
      operator: "ufone",
      country_id: 162,
      language_id: 7,
    };

    MobilePackage(payload)
      .then((data) => {
        if (data.status === 200) {
          console.log('dadadadadad"""" :::', data.data);
          // setPayments(data.data);
          setLoading(false);
          setPackageName(
            bundle === "daily"
              ? data.data[0].package_name
              : data.data[1].package_name
          );
          setPackagePrice(
            bundle === "daily"
              ? data.data[0].package_rate
              : data.data[1].package_rate
          );
          setPackageDescription(
            bundle === "daily"
              ? data.data[0].package_description
              : data.data[1].package_description
          );
          setTerms(
            bundle === "daily"
              ? data.data[0].terms_and_conditions
              : data.data[1].terms_and_conditions
          );
          setPackageValue(
            bundle === "daily"
              ? data.data[0].package_id
              : data.data[1].package_id
          );
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const renderButton = () => {
    return resendTimer <= 0 ? (
      <button
        style={{ cursor: "pointer" }}
        className="resend-text"
        onClick={() => {
          LoginFunction(number);
          setResendTimer(60);
          setResendStatus(true);
        }}
      >
        Resend OTP
      </button>
    ) : (
      <button className="resend-text">
        OTP will Expire in{" "}
        <span
          style={{
            color: "#1E1E1E",
            fontFamily: "Manrope",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "normal",
          }}
        >
          {resendTimer} seconds
        </span>
      </button>
    );
  };
  const renderTime = () => React.Fragment;

  useEffect(() => {
    if (resendStatus) {
      resendTimer > 0 &&
        setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
  }, [resendTimer, resendStatus]);

  const LoginFunction = (number) => {
    setLoading(false);
    // if (country == "pk") {
    if (number === "") {
      setError(`${t("is_empty")}`);
    } else if (number.substr(0, 2) == "03" && number.length == "11") {
      setError("Invalid entry. Required Pattern : +92300-0000000");
    } else if (number.substr(0, 1) == "3" && number.length == "10") {
      setLoading(true);
      setError("");

      let netCheck = {
        msisdn: number,
      };

      checkNetwork(tokenCheck, netCheck).then((data) => {
        if (data !== undefined) {
          console.log("data network is :::", data);
          if (data.status === 200) {
            if (data.data.network_type === "postpaid" && bundle !== "monthly") {
              setLoading(false);
              Modal.confirm({
                title: "Information",
                icon: <ExclamationCircleOutlined />,
                content: "This package is only for prepaid customers",
                okText: "Ok",
                centered: true,
                cancelText: () => null,
                closable: true,
              });
              return;
            } else {
              let pakistanPayload = {
                msisdn: "92" + number,
                package_id: 42,
                country_id: 162,
              };
              iraqLandingCharge(pakistanPayload).then((data) => {
                console.log("My Payloadss", data);
                if (data.status === 200) {
                  setResendStatus(true);
                  setLoading(false);
                  setError("");
                  setIsOtp(true);
                  // setOtp(data.pin);
                  setRedirectLoading(false);
                } else {
                  setLoading(false);
                  setError(data.message);
                }
              });
            }
          }
        }
      });
    } else {
      setError("Invalid number. Please Enter ufone Number");
    }
    // }
  };

  const onSubmit = () => {
    if (otp.length === 0) {
      return;
    }
    if (otp.length !== 4) {
      setError(`${t("four_digits")}`);
    } else {
      setLoading(true);
      let otpPayload = {
        msisdn: "92" + number,
        package_id: 42,
        country_id: 162,
        otp: otp,
        marketPartner: "web",
      };

      iraqLandingCharge(otpPayload)
        .then((data) => {
          console.log("response data: ", data);
          if (data.status === 200) {
            setLoading(false);
            setError("Package is subscribed succesfully");
            setTimeout(() => {
              // window.ttq.track("AddToWishlist");
              console.log("hello world");
              setRedirectTo(true);
            }, 1000);
            // } else {
            //   setLoading(false);
            //   setError(data.data.msg);
            // }
          } else {
            setLoading(false);
            console.log("hello xxx");
            setError(data.message);
          }
        })
        .catch((err) => {
          setError("Invalid OTP");
          setLoading(false);
        });
    }
  };
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FF1E1E" }} spin />
  );
  const buttonAntIcon = (
    <LoadingOutlined style={{ fontSize: 25, color: "white" }} spin />
  );

  if (redirectTo) {
    window.location.replace("https://fitflexapp.com/checkuserlp");
  }

  if (redirectLoading) {
    return (
      <div className="loader">
        <Spin
          className="spinner"
          indicator={antIcon}
          tip="Fetching Details..."
        />
      </div>
    );
  }
  // function toggleClick(language) {
  //   setLoading(true);
  //   i18n.changeLanguage(language);
  //   setLang(language);
  // }
  // function handleMenuClick(e) {
  //   e.key == "1"
  //     ? toggleClick("ar")
  //     : e.key == "2"
  //     ? toggleClick("en")
  //     : e.key == "3"
  //     ? toggleClick("id")
  //     : toggleClick("en");
  // }

  // const menu_pk = (
  //   <Menu onClick={handleMenuClick} className="menu_item">
  //     <Menu.Item key="2">English</Menu.Item>
  //   </Menu>
  // );

  return (
    <>
      {/* <Helmet>
        <script>{TikTokIntegrationScript}</script>
      </Helmet> */}
      <Modal
        // title="Basic Modal"
        closable
        visible={open}
        closeIcon={<CloseOutline />}
        // onOk={handleOk}
        onCancel={() => setOpen(false)}
        footer={null}
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          borderRadius: "20px",
          padding: "20px",
        }}
        bodyStyle={{
          borderRadius: "20px",
          padding: "30px",
        }}
      >
        <h1
          style={{
            color: "#000",
            textAlign: "center",
            fontFamily: " Manrope",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "92.6%",
            marginBottom: "20px",
            marginTop: "15px",
          }}
        >
          Terms And Conditions
        </h1>
        {terms?.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <ul>
                <li
                  style={{
                    color: " #434343",
                    fontFamily: "Manrope",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                  }}
                >
                  {item}
                </li>
              </ul>
            </React.Fragment>
          );
        })}
        {/* // <p>Some contents...</p>
        // <p>Some contents...</p> */}
      </Modal>
      <div className="main-container-div">
        <div className="main-left-container-div">
          {/* <p className="main-left-heading-one">FITFLEX</p> */}
          {/* <Dropdown overlay={menu_pk}>
            <a className="dropdown-ln" onClick={handleMenuClick}>
              {lang.toUpperCase()}
              <GlobalOutlined
                style={{ color: "#ff1e1e", marginLeft: "20px" }}
              />
            </a>
          </Dropdown> */}

          <img src={Fitflex} alt="fitflexLogo" />
          <p className="main-left-heading-two">World Class Fitness App</p>
          <p className="main-left-heading-three">
            Start Your Fitness Journey with 400+ HD Quality Videos
          </p>
          {isOtp ? (
            <>
              <p className="enter-number-and-otp-text">
                Enter Your 4 digit pin here
              </p>
              <OTPInput
                value={otp}
                onChange={setOtp}
                autoFocus={false}
                OTPLength={4}
                otpType="number"
                disabled={false}
                // secure
                style={{
                  justifyContent: "center",
                }}
                inputClassName="otpinputDiv"
                className="otp-box"
              />
              <ResendOTP
                renderButton={renderButton}
                renderTime={renderTime}
                onResendClick={() => console.log("Resend clicked")}
              />
              <p className="error-text">{error}</p>
              <button className="continueButton-new" onClick={() => onSubmit()}>
                {loading ? <Spin indicator={buttonAntIcon} /> : "Continue"}
              </button>
            </>
          ) : (
            <>
              <p className="enter-number-and-otp-text">
                Enter Your Mobile Number Below
              </p>
              <div className="input-div">
                <img
                  src={flag}
                  alt="flagIcon"
                  className="flagstyle"
                  style={{
                    marginLeft: "5px",
                    width: "10%",
                    border: "2px solid black",
                  }}
                />
                <Input
                  className="inputfield"
                  type="number"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  placeholder="XXXXXXXXXX"
                  bordered={false}
                  prefix={
                    <>
                      <div
                        style={{
                          borderLeft: "1px solid #6f6f6f",
                          height: "30px",
                        }}
                      ></div>
                      <span
                        style={{
                          fontSize: 16,
                          color: "#6f6f6f",
                          // borderLeft: "1px solid black",
                          paddingLeft: "10px",
                          // height: "25px",
                        }}
                      >
                        +92
                      </span>
                    </>
                  }
                  suffix={
                    <>
                      <img src={JazzLogo} />
                    </>
                  }
                />
              </div>
              <p className="package-text">
                *Rs {packagePrice}
                {packageDescription}
              </p>
              <p className="error-text">{error}</p>

              <button
                className="continueButton-new"
                onClick={() => LoginFunction(number)}
              >
                {loading ? <Spin indicator={buttonAntIcon} /> : "continue"}
              </button>
            </>
          )}
          <button
            className="termsAndConditionBtn"
            onClick={() => {
              setOpen(true);
            }}
          >
            <img src={Arrow} alt="arrow" />
            <div
              style={{ height: "15px", border: "0.5px solid rgba(0, 0, 0, 1)" }}
            ></div>
            Terms and Conditions
          </button>
        </div>
        <div className="main-right-container-div">
          {/* <img
          src={GirlDancingImg}
          style={{ width: "66%", height: "100%" }}
          alt="girlDancing"
        /> */}
        </div>
      </div>
    </>
  );
};

export default UfoneLandingPage;
